module.exports = __webpack_public_path__ + "img/che.798e6bc8.png";